/**
 * @generated SignedSource<<6b5f13b8dfe4a56a12543975132a69dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Transaction_receipt$data = {
  readonly status: boolean;
  readonly transactionHash: string;
  readonly " $fragmentSpreads": FragmentRefs<"ApproveCollection_receipt" | "ApproveCurrency_receipt" | "BulkTransfer_receipt" | "CancelAllOrders_receipt" | "CancelDeal_receipt" | "CancelOrder_receipt" | "ConfigureDrop_receipt" | "CreateDropTransaction_receipt" | "DealAccept_receipt" | "Redeem_receipt" | "Transfer_receipt" | "UnknownTransaction_receipt">;
  readonly " $fragmentType": "Transaction_receipt";
};
export type Transaction_receipt$key = {
  readonly " $data"?: Transaction_receipt$data;
  readonly " $fragmentSpreads": FragmentRefs<"Transaction_receipt">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Transaction_receipt",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionHash",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApproveCollection_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApproveCurrency_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DealAccept_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BulkTransfer_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelAllOrders_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelDeal_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelOrder_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Transfer_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateDropTransaction_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UnknownTransaction_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Redeem_receipt"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConfigureDrop_receipt"
    }
  ],
  "type": "TransactionReceiptType",
  "abstractKey": null
};

(node as any).hash = "f66f47c58f58e3ac329adbe518b059d3";

export default node;
